import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-adopt",
  "use": "icon-adopt-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-adopt\"><path d=\"M13 3l-7.548 8L1 6.28\" stroke=\"#69E0AF\" fill=\"transparent\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol